import { IsNotEmpty, IsDefined } from 'class-validator';
import { computed } from 'mobx';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { ContextService } from 'src/core/services/context.service';
import { factory, OData, $data } from 'src/core/services/data/JayDataContext';

export class MarketDataService extends DataService<typeof Model.General.Logic.ViewModels.MarketItem, Model.General.Logic.ViewModels.MarketItem, MarketItem> {
	constructor(contextService: ContextService, entitySet: (context: OData.Container) => $data.EntitySet<typeof Model.General.Logic.ViewModels.MarketItem, Model.General.Logic.ViewModels.MarketItem>) {
		super(contextService, entitySet);
	}

	protected map(entity: Model.General.Logic.ViewModels.MarketItem): MarketItem {
		return new MarketItemModel(entity);
	}

	public static make(ctx?: any): MarketDataService {
		return new MarketDataService(ctx, ctx => ctx.Markets);
	}
	id: number = -1;
	public add(defaultLanguage: string) {
		const entity = new Model.General.Logic.ViewModels.MarketItem();
		entity.id = this.id--;
		entity.name = '';
		entity.defaultTaxId = 1;
		entity.defaultMargin = '0.25';
		(entity as any).dynamicProperties['displayName'] = { [defaultLanguage]: '' };
		return entity;
	}
}

export class MarketItemModel extends EntityModel<Model.General.Logic.ViewModels.MarketItem, MarketItem> implements MarketItem {

	@property<MarketItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<MarketItemModel>(o => o.entity.name, (o, value) => o.entity.name = value)
	@IsDefined({
		message: 'name should not be empty'
	})
	@IsNotEmpty({
		message: 'name should not be empty'
	})
	public name: string;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	public dynamicProperties: {};

	@property<MarketItemModel>(o => o.entity.currencyId, (o, value) => o.entity.currencyId = value)
	@IsDefined({
		message: 'currency should not be empty'
	})
	public currencyId: number;

	@property<MarketItemModel>(o => o.entity.marketPriceType, (o, value) => o.entity.marketPriceType = value)
	@IsDefined({
		message: 'market Price Type should not be empty'
	})
	public marketPriceType: number;

	@property<MarketItemModel>(o => o.entity.defaultMargin, (o, value) => o.entity.defaultMargin = value)
	@IsDefined({
		message: 'market Default Margin should not be empty'
	})
	public defaultMargin: number;

	@property<MarketItemModel>(o => o.entity.requiresPayment, (o, value) => o.entity.requiresPayment = value)
	public requiresPayment: boolean;

	@property<MarketItemModel>(o => o.entity.depositPercent, (o, value) => o.entity.depositPercent = value)
	@IsDefined({
		message: 'market Deposit Percent should not be empty'
	})
	public depositPercent: number;

	@property<MarketItemModel>(o => o.entity.invoiceDueDateInDays, (o, value) => o.entity.invoiceDueDateInDays = value)
	@IsDefined({
		message: 'market Due date should not be empty'
	})
	public invoiceDueDateInDays: number;

	@property<MarketItemModel>(o => o.entity.defaultTaxId, (o, value) => o.entity.defaultTaxId = value)
	@IsDefined({
		message: 'default tax should not be empty'
	})
	public defaultTaxId: number;

	@property<MarketItemModel>(o => o.entity.marginPolicy, (o, value) => o.entity.marginPolicy = value)
	@IsDefined({
		message: 'market margin policy should not be empty'
	})
	public marginPolicy: number;

	@computed
	public get marginPolicyText(): string {
		switch (this.marginPolicy) {
			case 0:
				return 'Margin only from Market';
			case 1:
				return 'Margin only from Supplier';
			case 2:
				return 'Margin from Market + Supplier';
		}
		return null;
	}
}



// WEBPACK FOOTER //
// ./src/app/general/market/form/market-form.data.ts